import { Card } from "@capioweb/ui-components"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
	ContentLink,
	PropertyCategory,
	QBankImage,
	XhtmlString,
} from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { imageBlockDataToImageProps } from "../../utils"
import { sendArticleDataLayerPush } from "../../utils/piwikPro"
import { onFavButtonClick } from "./api"

export interface MyPagesPersonalizedArticleProps {
	name: string
	heading: StringProperty
	preamble: XhtmlString
	imageDesktopBlock?: QBankImage
	categories: PropertyCategory
	contentLink: ContentLink
	isSavedArticle?: boolean
	modelType: string
}

const MyPagesPersonalizedArticleBlock: React.FC<MyPagesPersonalizedArticleProps> =
	(props) => {
		const [filled, setFilled] = useState(props.isSavedArticle ?? false)
		return (
			<Link to={props.contentLink?.url ?? "#"} style={{ width: "100%" }}>
				<Card
					h={48.5}
					media={
						props.imageDesktopBlock?.media?.value ? (
							<img
								{...imageBlockDataToImageProps(props.imageDesktopBlock)}
								loading="lazy"
							/>
						) : null
					}
					tag={
						props.categories.value.length > 0 &&
						props.categories.value[0].description
					}
					borderColor="blue33"
				>
					{/* <Card.FavButton
						onClick={(e) => {
							e.preventDefault()
							onFavButtonClick(
								props.contentLink.guidValue,
								props.isSavedArticle,
								setFilled
							)
							sendArticleDataLayerPush("saved", props.heading.value)
						}}
						filled={filled}
					/> */}
					<Card.Title>{props.heading?.value || props.name}</Card.Title>
					{props.preamble?.value !== "" && (
						<Card.Preamble>{props.preamble.value}</Card.Preamble>
					)}
				</Card>
			</Link>
		)
	}

export { MyPagesPersonalizedArticleBlock }
